import { createAPI } from '@common'

export default {
  // 获取任务详情
  getTasks: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/OFXTQMBO;0w20ubtlt',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20ubtlt', 'get', { params: config.params })
    }
  },
  // 删除选题
  deleteTasks: (config) => createAPI('customEncryptApiName-1/0w20ubtlt0efmfuf', 'post', config),
  // 跟踪任务
  getTasksLogs: (config) => {
    if (config.hubConfig) {
      createAPI('customEncryptApiName-1/OFXTQMBO;0w20ubtlt0mpht',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      createAPI('customEncryptApiName-1/0w20ubtlt0mpht', 'get', { params: config.params })
    }
  }
}
